import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import "./NewEnrollmentForm.css";

import { Check } from "@mui/icons-material";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { DatePicker } from "@mui/x-date-pickers";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import styled from "@emotion/styled";
import {
  maskAccountNumber,
  formatNumber,
  maskedAccountId,
  maskSSNNumber,
} from "../common/Utils";
import React, { useEffect, useState } from "react";
import EnrollmentModal from "./EnrollmentModal";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { getbenifitlist, checkDuplicateSsn } from "../common/constants/globalconstants";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import SSNTextField from "../common/SSNTextField";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  borderRadius:"10px"
};

const BackButton = styled(Button)({
  borderColor: "#002d82",
  border: "2px solid",
  color: "#002d82",
  borderRadius: "5px",
});

const ResetButton = styled(Button)({
  borderColor: "#e81313",
  border: "2px solid",
  color: "#e81313",
  borderRadius: "5px",
});

const SubmitButton = styled(Button)({
  backgroundColor: "#002d82",
  color: "white",
  borderRadius: "5px",
});
let k = "";
let p = "";
let r = "";
let s = "";
let y = "";
var today_date = new Date();
//today_date = (today_date.getMonth() + 1) + '/' + today_date.getDate() + '/' + today_date.getFullYear()

k = today_date.getMonth() + 1;
if (today_date.getMonth() + 1 < 10) {
  p = today_date.getMonth() + 1;
  k = "0" + p;
}
s = today_date.getDate();
if (today_date.getDate() < 10) {
  r = today_date.getDate();
  s = "0" + r;
}
y = today_date.getFullYear();
var today_date = k + "/" + s + "/" + y;

const formFields = {
  enrollmentId: 0,
  firstName: "",
  lastName: "",
  SSN: "",
  mask_ssn: "",
  accountNum: "",
  mask_accNum: "",
  address: {
    street: "",
    city: "",
    state: "",
    zip_code: "",
  },
  tele_number: "",
  contact: "",
  repre_payee: "",
  acc_type: "Checking",
  enroll_date: today_date,
  picker_date: new Date(),
  medi: "",
  resiID: "",
  allowance: "",
  benefitTypes: [],
};

var concatenatedVal = "";

function NewEnrollmentForm() {
  const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);

  const [bt, setbt] = useState([{}]);
  const [loading, setloading] = useState(false); 
  const carefacilitydetails = useSelector((state) => state.carefacilitydetails);
  const [enrollmentFields, setFields] = useState(formFields);
  const [selectedRepreRadioValue, setRepreRadioValue] = useState("Yes");
  const [selectedAccRadioValue, setAccRadioValue] = useState("Checking");
  const [nameRowHeight, setRowHeight] = useState("65px");
  const [ssnRowHeight, setSSNHeight] = useState("65px");
  const [allowanceHeight, setAllowanceHeight] = useState("120px");
  const [checked, setChecked] = useState([]);
  const [duplicateSsn, setDuplicateSsn] = useState(false);
  const [duplicateMsg, setDuplicateMsg] = useState("");
  //const [backspaceKey, setBackspaceKey] = useState(false);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  //const [childCareFacility, setChildCareFacility] = useState("Child1");
  

  useEffect(() => {
    setCareFacilityDefaultVals();
  }, [carefacilitydetails]); //it should come on every render

  const setCareFacilityDefaultVals = () => {
    setFields({
      ...enrollmentFields,
      tele_number: carefacilitydetails.phone,
      contact: carefacilitydetails.contactPerson,
      address: {
        street: carefacilitydetails.address,
        city: carefacilitydetails.city,
        state: carefacilitydetails.state,
        zip_code: carefacilitydetails.zip,
      },
      mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
      accountNum: carefacilitydetails.accountNumber,

      acc_type: carefacilitydetails.accountType,
    });
  };

  useEffect(() => {
    setloading(true);
    if (storetoken !== "") {

      const getBenefits = async() =>{
        try{
          const data = await axiosInstance.get(`${getbenifitlist}`);
            if (data.data.isSuccess) {
            setbt(data.data.result);
            setloading(false);
            seterrormodalOpen(false);
            }
            else if(!data.data.isSuccess){
              seterrormodalOpen(true);
            }
            setloading(false);
          }
          catch(err)  {
            console.log(err.message)
            seterrormodalOpen(true);
            setloading(false);
          };
      }
      getBenefits();
    }
  }, []);

  //pending promise un resolved

  let benefitTypeList = [...bt];

  //getting row data as a state from ddl page to edit enrol page
  const location = useLocation();
  const [prevLocation, setPrevLocation] = useState(null);

  useEffect(() => {
    if (location.pathname !== prevLocation?.pathname) {
      setPrevLocation(location);
    }
  }, [location]);

  useEffect(() => {
    var majorarray = [...benefitTypeList];
    var emptyarray = [],
      initialsarray = [];
    //const location=useLocation();
    if (action == "edit") {

      //test code below
      var ddlpaarray = location.state.benefitTypes;
      var descriptionarray = [...ddlpaarray]; //contains all fullform btdescription

      descriptionarray.map((ele) => {
        majorarray.map((e) => {
          if (ele === e.btDescriptions)
            initialsarray = [...initialsarray, e.btInitials];
        });
      });
      setChecked(initialsarray);
      setFields({ ...enrollmentFields, benefitTypes: initialsarray });
      //benefitTypeList=[...initialsarray]
      //test code above

      if (location.state.representativePayee === "YES") {
        setRepreRadioValue("Yes");
      } else {
        setRepreRadioValue("No");
      }
      if (location.state.accountType === "Checking")
        setAccRadioValue("Checking");
      else setAccRadioValue("Savings");

      setFields({
        ...enrollmentFields,
        enrollmentId: location.state.enrollmentId,
        allowance: location.state.allowance,
        tele_number: location.state.phone,
        firstName: location.state.payeeFirstName,
        lastName: location.state.payeeLastName,

        benefitTypes: initialsarray, //we dont need full array
        //location.state.benefitTypes
        //mask_accNum: maskAccountNumber(location.state.accountNo),
        mask_accNum: maskedAccountId(location.state.accountNo),
        SSN: location.state.ssn,
        mask_ssn: location.state.ssn,
        accountNum: maskAccountNumber(location.state.accountNo),
        address: {
          street: location.state.address,
          city: location.state.city,
          state: location.state.state,
          zip_code: location.state.zip,
        },

        contact: location.state.contact,

        repre_payee: location.state.representativePayee === "YES" ? "Yes" : "No",
        /*
                repre_payee: (location.state.representativePayee==="YES")
                ?
                setRepreRadioValue("Yes") 
                :
                setRepreRadioValue("No"),
                */

        acc_type: location.state.accountType,

        /*
                acc_type: (location.state.accountType==="Checking")?
                setAccRadioValue("Checking"):setAccRadioValue("Savings"),
                */
        enroll_date: location.state.enrollmentDate,

        picker_date: location.state.enrollmentDate,
        medi: location.state.medicaId,
        resiID: location.state.residentId,
        allowance: location.state.allowance,
      });
    }
  }, [bt]); //use effect ends

  const [alertState, setAlertstate] = useState({
    open: false,
    message: "",
    vertical: "top",
    horizontal: "center",
  });
  const [fieldErrors, setErrors] = useState({
    err_firstName: false,
    err_lastName: false,
    err_SSN: false,
    firstName_helperText: "",
    lastName_helperText: "",
    SSN_helperText: "",
  });
  const [showSSN, setShowSSN] = useState(false);
  const [showSSNp, setShowSSNp] = useState(false);
  const [hasFocus, setFocus] = useState(false);
  const navigate = useNavigate();
  const { action } = useParams();

  let k = "";
  let p = "";
  let r = "";
  let s = "";
  let y = "";
  const dateHandler = (e) => {
    var date = new Date(e.$d);
    k = date.getMonth() + 1;
    if (date.getMonth() + 1 < 10) {
      p = date.getMonth() + 1;
      k = "0" + p;
    }
    s = date.getDate();
    if (date.getDate() < 10) {
      r = date.getDate();
      s = "0" + r;
    }
    y = date.getFullYear();
    var finalDate = k + "/" + s + "/" + y;
    setFields({
      ...enrollmentFields,
      enroll_date: finalDate,
      picker_date: date,
    });
  };

  // const handleBackspaceKey = (event) =>{
  //     if(event.key == "Backspace"){
  //         setBackspaceKey(true);
  //     }else{
  //         setBackspaceKey(false);
  //     }
  // }
  const inputHandler = (e) => {    
    e.preventDefault();
    if (e.target.name === "add_street") {
      setFields({
        ...enrollmentFields,
        address: { ...enrollmentFields.address, street: e.target.value },
      });
    } else if (e.target.name === "add_city") {
      setFields({
        ...enrollmentFields,
        address: { ...enrollmentFields.address, city: e.target.value },
      });
    } else if (e.target.name === "add_state") {
      setFields({
        ...enrollmentFields,
        address: {
          ...enrollmentFields.address,
          state: e.target.value.toUpperCase(),
        },
      });
    } else if (e.target.name === "add_code") {
      const regex = /^[0-9]+$/;
      if (regex.test(e.target.value)) {
        setFields({
          ...enrollmentFields,
          address: { ...enrollmentFields.address, zip_code: e.target.value },
        });
      } else {
        setFields({
          ...enrollmentFields,
          address: { ...enrollmentFields.address, zip_code: "" },
        });
      }
    } else if (e.target.name === "accountNum") {
      let accNumVal = enrollmentFields.accountNum;
      const value = e.target.value;
      const valueLen = value.length;
      accNumVal = accNumVal + value[valueLen - 1];
      const accountId = maskAccountNumber(e.target.value);
      setFields({
        ...enrollmentFields,
        mask_accNum: accountId,
        accountNum: accNumVal,
      });
    } else if (e.target.name === "tele_number") {
      const regex = /^[0-9]+$/;
      if (regex.test(e.target.value)) {
        const newNum = formatNumber(e.target.value);
        setFields({ ...enrollmentFields, tele_number: newNum });
      } else {
        setFields({ ...enrollmentFields, tele_number: "" });
      }
    } else if (e.target.name === "repre_payee") {
      setFields({ ...enrollmentFields, [e.target.name]: e.target.value });
      setRepreRadioValue(e.target.value);
    }  
    else if (e.target.name === "benefitTypes") {
      let tempArr = enrollmentFields.benefitTypes;
      var updatedList = [...checked];
      if (e.target.checked) {
        updatedList = [...checked, e.target.value]; //checked is an array containing initials
      } else {
        updatedList.splice(checked.indexOf(e.target.value), 1);
      }
      setChecked(updatedList);
      setFields({ ...enrollmentFields, benefitTypes: updatedList });
    } else if (e.target.name === "allowance") {
      ////const regex = /^[0-9]*\.?[0-9]{0,2}$/;
      const regex =/^$|^[0-9]+(\.[0-9]{0,2})?$/;
      if (regex.test(e.target.value)) {
      setFields({ ...enrollmentFields, allowance: e.target.value });
      }
      setErrors({
        ...fieldErrors,
        err_allowance: false,
        allowance_helperText: "",
      });
      setAllowanceHeight("95px");
    } else {
      if (e.target.name === "SSN") {
        const regex = /^[0-9]*$/;
        if (e.target.value === "") {
          concatenatedVal = "";
          const masked_ssn = maskSSNNumber(concatenatedVal);
          setFields({
            ...enrollmentFields,
            mask_ssn: masked_ssn,
            SSN: concatenatedVal,
          });
        }
        if (regex.test(e.target.value)) {
          const value = e.target.value;
          //let masked_ssn;
          if (value && value.length > 0) {
            //if(action == "edit"){
            let masked_ssn = maskSSNNumber(value);
            setFields({
              ...enrollmentFields,
              mask_ssn: masked_ssn,
              SSN: value,
            });
          }
          if(value && value.length ===9){
            setErrors({
              ...fieldErrors,
              err_SSN: false,
              SSN_helperText:"",
            });
            setRowHeight("65px");
          }
        }
      } else {
        setFields({ ...enrollmentFields, [e.target.name]: e.target.value });
        if (e.target.name === "firstName") {
          setErrors({
            ...fieldErrors,
            err_firstName: false,
            firstName_helperText: "",
          });
          setRowHeight("65px");
        }
        if (e.target.name === "lastName") {
          setErrors({
            ...fieldErrors,
            err_lastName: false,
            lastName_helperText: "",
          });
          setRowHeight("65px");
        }
      }
    }
  };

  const resetFields = () => {
    setFields({ ...formFields, benefitTypes: [] });
    setRepreRadioValue("Yes");
    setChecked([]);
    //setCareFacilityDefaultVals();
    //setAccRadioValue("Checking") ;
    if(action == 'edit'){
      setFields({
        ...formFields,
        enrollmentId:location.state.enrollmentId,
        firstName: "",
        lastName: "",
        SSN: "",
        repre_payee: "Yes",
        //enroll_date: today_date,
        //picker_date: new Date(),
        picker_date: location.state.enrollmentDate,
        enroll_date: location.state.enrollmentDate,
        medi: "",
        resiID: "",
        tele_number: carefacilitydetails.phone,
        contact: carefacilitydetails.contactPerson,
        address: {
          street: carefacilitydetails.address,
          city: carefacilitydetails.city,
          state: carefacilitydetails.state,
          zip_code: carefacilitydetails.zip,
        },
        mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
        accountNum: carefacilitydetails.accountNumber,
  
        acc_type: carefacilitydetails.accountType,
        picker_date: location.state.enrollmentDate,
        allowance: location.state.allowance,
      });
    }
    else{
      setFields({
        ...formFields,
        firstName: "",
        lastName: "",
        SSN: "",
        repre_payee: "Yes",
        enroll_date: today_date,
        picker_date: new Date(),
        medi: "",
        resiID: "",
        allowance: "",
        tele_number: carefacilitydetails.phone,
        contact: carefacilitydetails.contactPerson,
        address: {
          street: carefacilitydetails.address,
          city: carefacilitydetails.city,
          state: carefacilitydetails.state,
          zip_code: carefacilitydetails.zip,
        },
        mask_accNum: maskedAccountId(carefacilitydetails.accountNumber),
        accountNum: carefacilitydetails.accountNumber,
  
        acc_type: carefacilitydetails.accountType,
      });
    }
    
    setErrors({
      err_firstName: false,
      err_lastName: false,
      err_SSN: false,
      err_allowance: false,
      firstName_helperText: "",
      lastName_helperText: "",
      SSN_helperText: "",
      allowance_helperText: "",
    });
    //setCareFacilityDefaultVals();


  };

  const handleAlert = () => {
    setAlertstate({ ...alertState, open: false, message: "" });
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    var error = false;
    if(enrollmentFields.repre_payee === ""){
      setFields({ ...enrollmentFields, 
        "repre_payee": selectedRepreRadioValue,
        "acc_type": selectedAccRadioValue });
    }
    if (enrollmentFields.firstName === "") {
      setErrors({
        ...fieldErrors,
        err_firstName: true,
        firstName_helperText: "First Name field can't be blank",
      });
      setRowHeight("120px");
      setFocus("enrollmentFName");
      window.scrollTo(0, 0);
      error = true;
      return;
    }
    if (enrollmentFields.lastName === "") {
      setErrors({
        ...fieldErrors,
        err_lastName: true,
        lastName_helperText: "Last Name can't be blank",
      });
      setRowHeight("120px");
      setFocus("enrollmentLName");
      window.scrollTo(0, 0);
      error = true;
      return;
    }
    if (enrollmentFields.SSN === "") {
      setErrors({
        ...fieldErrors,
        err_SSN: true,
        SSN_helperText: "SSN can't be blank",
      });
      setSSNHeight("120px");
      setFocus("enrollmentSSN");
      window.scrollTo(0, 0);
      error = true;
      return;
    }
    if (enrollmentFields.SSN.length < 9) {
      setErrors({
        ...fieldErrors,
        err_SSN: true,
        SSN_helperText:
          "SSN should be a 9 digits numeric",
      });
      setSSNHeight("120px");
      setFocus("enrollmentSSN");
      window.scrollTo(0, 0);
      error = true;
      return;
    }
    
    if (enrollmentFields.benefitTypes.length === 0) {
      setAlertstate({
        ...alertState,
        open: true,
        message: "You have to select atleast one type(s) of benefits",
      });
      error = true;
      return;
    }

    if (!error && action!= "edit") {
      checkDuplicateSsnForNewRecord();
    }
    else{
      setDuplicateSsn(false);
      setDuplicateMsg("");
      setOpen(true);
    }

  };

  const createInputRequest=()=>{
    return {
      "enrollmentId": enrollmentFields.enrollmentId,
      "ssn": enrollmentFields.SSN
    }
  }
  
  const checkDuplicateSsnForNewRecord = async() =>{
    try {
      setloading(true);
      const inputRequest= createInputRequest();
      const response = await axiosInstance.post(`${checkDuplicateSsn}`, JSON.stringify(inputRequest)); 
  
        if(response.data.Message === "Duplicate found"){
          setDuplicateSsn(true);
          setDuplicateMsg(response.data.result);
        }
        else {
          setDuplicateSsn(false);
        }
        setloading(false);
        setOpen(true);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

  const handleClose = () => {
    //setFields({...enrollmentFields})
    setOpen(false);
  };

  const handleModalClose=()=>{
    setModalOpen(false);
    navigate("/directDepositListing");
  }

  const handleClickShowSSN = () => {
    setShowSSN(!showSSN);
  };
  const handleClickShowSSNp = () => {
    setShowSSNp(!showSSNp);
  };

  const handleOnBlur = (e) => {
    if (!e.target.value.trim()) {
      setFocus(false);
    }
  };

  const [snackbardata, setsnackbardata] = useState(false);
  function handlesnackbardata(data) {
    setsnackbardata(data);
  }

  useEffect(() => {
    setTimeout(() => {
      setsnackbardata(false);
    }, 5000);
  }, [snackbardata]);

  return (
    <div>
      {loading && (
        <>
          <Backdrop
            sx={{
              color: "white",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={loading}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
          </Backdrop>
        </>
      )}
      <Box
        sx={{
          flexDirection: "column",
          alignItems: "center",
          p: "0 5%",
          backgroundColor: "#fcfcfc",
          borderTop: "2px solid #dfe3e8",
        }}
      >
        {action == "edit" ? (
          <h2 className="header">Update Enrollment Form</h2>
        ) : (
          <h2 className="header">New Enrollment Form</h2>
        )}
        <Divider
          variant="fullwidth"
          sx={{ backgroundColor: "#dfe3e8" }}
        ></Divider>
        <Grid container sx={{ mt: "27px", width: "100%" }}>
          <Snackbar
            open={alertState.open}
            autoHideDuration={5000}
            onClose={handleAlert}
            anchorOrigin={{
              vertical: alertState.vertical,
              horizontal: alertState.horizontal,
            }}
          >
            <Alert
              onClose={handleAlert}
              severity="error"
              sx={{ width: "100%" }}
            >
              {alertState.message}
            </Alert>
          </Snackbar>
          <Grid
            item
            xs={7.7}
            sx={{
              p: "5px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              mr: "27px",
              backgroundColor: "white",
            }}
          >

            {/*<Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${nameRowHeight}`, mb: "5px" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  Care Facility <span id="note">*</span>
                </p>
                <TextField
                                        select
                                        id="care-facility-list"
                                        label=""
                                        value={childCareFacility}
                                        defaultValue="Select"
                                        variant="outlined"
                                        name="childCareFacility"
                                        //onChange={onChangeFacility}
                                        sx={{ minWidth: "165px", "& .MuiSelect-select":{ padding: "8px 12px !important", minWidth:"165px", width:"165px", height:"9px !important"} }}
                                        //className="facility-account"
                                        SelectProps={{
                
                                          MenuProps: {
                                            PaperProps: {
                                              style: {
                                                maxHeight: 200,
                                              },
                                            },
                                          },
                                        }}
                                      >
                                        
                                        <MenuItem key="Child1" value="Child1">Child1</MenuItem>
                                        <MenuItem key="Child2" value="Child2">Child2</MenuItem>
                                        <MenuItem key="Child3" value="Child3">Child3</MenuItem>
                                        <MenuItem key="Child4" value="Child4">Child4</MenuItem>
                                      </TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">CF Account Number</p>
                <TextField
                  disabled
                  variant="outlined"
                  margin="none"
                  label=""
                  sx={{ width: "190px", "& .MuiInputBase-root input":{height: "20px !important", padding: "10px 10px !important"} }}
                  inputProps={{ maxLength: 10, readOnly: true }}
                  value={enrollmentFields.mask_accNum}
                  title={enrollmentFields.accountNum}
                  name="accountNum"
                  onChange={inputHandler}
                />
              </Box>
              
            </Stack>

           <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider> */}

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${nameRowHeight}`, mb: "5px" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  First Name <span id="note">*</span>
                </p>
                {fieldErrors.err_firstName ? (
                  <TextField
                    error
                    helperText={fieldErrors.firstName_helperText}
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="First Name"
                    value={enrollmentFields.firstName}
                    name="firstName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                    //className="form-textfield"
                  ></TextField>
                ) : (
                  <TextField
                    variant="outlined"
                    id="enrollmentFName"
                    margin="none"
                    label=""
                    placeholder="First Name"
                    value={enrollmentFields.firstName}
                    name="firstName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                    //className="form-textfield"
                    inputProps={{ maxLength: 50 }}
                  ></TextField>
                )}
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">
                  Last Name <span id="note">*</span>
                </p>
                {fieldErrors.err_lastName ? (
                  <TextField
                    error
                    helperText={fieldErrors.lastName_helperText}
                    variant="outlined"
                    margin="none"
                    label=""
                    placeholder="Last Name"
                    value={enrollmentFields.lastName}
                    name="lastName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                    //className="form-textfield"
                  ></TextField>
                ) : (
                  <TextField
                    variant="outlined"
                    id="enrollmentLName"
                    margin="none"
                    label=""
                    placeholder="Last Name"
                    value={enrollmentFields.lastName}
                    name="lastName"
                    onChange={inputHandler}
                    sx={{ width: "190px" }}
                    //className="form-textfield"
                    inputProps={{ maxLength: 50 }}
                  ></TextField>
                )}
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: `${ssnRowHeight}`, m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">
                  SSN <span id="note">*</span>
                </p>
                <SSNTextField
                  name="SSN"
                  onChange={inputHandler}
                  value={enrollmentFields.SSN}
                  showSSN={showSSN}
                  setFocus={setFocus}
                  handleOnBlur={handleOnBlur}
                  handleClickShowSSN={handleClickShowSSN}
                  field="enrollment"
                  editable="Yes"
                  formErrors={fieldErrors}
                />
                {/* <input type="hidden" value={enrollmentFields.SSN} name="SSN"/> */}
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">CF Account Number</p>
                <TextField
                  disabled
                  variant="outlined"
                  margin="none"
                  label=""
                  sx={{ width: "190px" }}
                  inputProps={{ maxLength: 10, readOnly: true }}
                  value={enrollmentFields.mask_accNum}
                  title={enrollmentFields.accountNum}
                  name="accountNum"
                  onChange={inputHandler}
                />
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              sx={{ width: "100%", height: "150px" }}
            >
              <p className="input-label">Address</p>
              <Box
                display="grid"
                sx={{
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gridTemplateRows: "auto",
                  gridTemplateAreas: `"street street street" "city state zip"`,
                  columnGap: 2,
                  rowGap: 1,
                  ml: "15px",
                }}
              >
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="Street"
                  value={enrollmentFields.address.street}
                  name="add_street"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "street" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  placeholder="City"
                  value={enrollmentFields.address.city}
                  name="add_city"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "city" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 2 }}
                  variant="outlined"
                  placeholder="State"
                  value={enrollmentFields.address.state}
                  name="add_state"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "state" }}
                ></TextField>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 6 }}
                  variant="outlined"
                  placeholder="Zip Code"
                  value={enrollmentFields.address.zip_code}
                  name="add_code"
                  onChange={inputHandler}
                  margin="none"
                  sx={{ gridArea: "zip" }}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                  pr: "20px",
                }}
              >
                <p className="input-label">Telephone No</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true, maxLength: 11 }}
                  variant="outlined"
                  margin="none"
                  placeholder="Telephone"
                  value={enrollmentFields.tele_number}
                  name="tele_number"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "45%",
                }}
              >
                <p className="input-label">Point of Contact</p>
                <TextField
                  disabled
                  inputProps={{ readOnly: true }}
                  variant="outlined"
                  margin="none"
                  placeholder="Contact"
                  value={enrollmentFields.contact}
                  name="contact"
                  onChange={inputHandler}
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
            </Stack>
            <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", m: "5px 0" }}
            >
              {/*<Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "340px",
                }}
              >
                <p inputProps={{ readOnly: true }} className="input-label">
                CF Account Type
                </p>
                <FormControl disabled={true}>
                  <RadioGroup
                    disabled={true}
                    name="radio-buttons-group"
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Radio
                        sx={{ pr: "0", pl: "0" }}
                        variant="outlined"
                        checked={selectedAccRadioValue === "Checking"}
                        onChange={inputHandler}
                        name="acc_type"
                        value="Checking"
                        label="Checking"
                      />{" "}
                      <span>Checking</span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Radio
                        sx={{ pr: "0" }}
                        variant="outlined"
                        checked={selectedAccRadioValue === "Savings"}
                        onChange={inputHandler}
                        name="acc_type"
                        value="Savings"
                        label="Savings"
                      />{" "}
                      <span>Savings</span>
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>*/}
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "335px",
                }}
              >
                <p className="input-label" inputProps={{ readOnly: true }}>
                  Representative Payee
                </p>
                <FormControl>
                  <RadioGroup
                    //disabled={true}
                    id="enrollmentPayee"
                    name="radio-buttons-group"
                    defaultValue="Yes"
                    value={selectedRepreRadioValue}
                    onChange={inputHandler}
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "150px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Radio
                        sx={{ pr: "0" }}
                        variant="outlined"
                        checked={selectedRepreRadioValue === "Yes"}
                        onChange={inputHandler}
                        name="repre_payee"
                        value="Yes"
                        label="Yes"
                      />{" "}
                      <span>Yes</span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Radio
                        sx={{ pr: "0" }}
                        variant="outlined"
                        checked={selectedRepreRadioValue === "No"}
                        onChange={inputHandler}
                        name="repre_payee"
                        value="No"
                        label="No"
                      />{" "}
                      <span>No</span>
                    </Box>
                  </RadioGroup>
                </FormControl>
              </Box>
            </Stack>
             <Divider
              variant="fullwidth"
              sx={{ backgroundColor: "#dfe3e8" }}
            ></Divider>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ width: "100%", height: "65px", mt: "5px" }}
            >
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "47%",
                }}
              >
                <p className="input-label">
                  Enrollment Date {action != "edit" ?<span id="note">*</span>:""}
                </p>
                <DatePicker
                  sx={{ ml: "0px", width: "59%" }}
                  disabled={action == "edit" ? true: false}
                  inputFormat="MM DD YYYY"
                  onChange={dateHandler}
                  value={dayjs(enrollmentFields.picker_date)}
                  size="small"
                ></DatePicker>
              </Box>
            </Stack>
          </Grid>

          <Grid
            item
            xs={4}
            sx={{
              p: "15px 16px",
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
            }}
          >
            <FormControl>
              <h2 className="benefit-header">
                Types of Benefits <span id="note">*</span>
              </h2>
              <FormGroup sx={{ mt: "20px" }}>
                {benefitTypeList.map((benefitTypes, idx) => {
                  return (
                    <FormControlLabel
                      key={idx}
                      sx={{ mb: "10px" }}
                      control={
                        <Checkbox
                          onChange={inputHandler}
                          checked={checked.includes(benefitTypes.btInitials)} //error this line is not used
                          name="benefitTypes"
                          value={benefitTypes.btInitials}
                          sx={{
                            color: "grey",
                            "&.Mui-checked": { color: "#002d82" },
                          }}
                        ></Checkbox>
                      }
                      label={
                        <Typography sx={{ color: "black" }}>
                          {benefitTypes.btDescriptions}
                        </Typography>
                      }
                    ></FormControlLabel>
                  );
                })}
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              border: "1.5px solid #dfe3e8",
              borderRadius: "5px",
              backgroundColor: "white",
              mt: "27px",
              p: "15px 16px",
            }}
          >
            <Box display="flex" flexDirection="row">
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "50%",
                }}
              >
                <p className="input-label">MEDICAID</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  onChange={inputHandler}
                  value={enrollmentFields.medi}
                  name="medi"
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "50%",
                }}
              >
                <p className="input-label">
                  Allowance
                </p>
                <TextField
                  disabled={action==="edit"? true: false}
                  className="number-input"
                  variant="outlined"
                  margin="none"
                  label=""
                  onChange={inputHandler}
                  InputProps={{
                    inputProps: { inputMode:'decimal', step: "any", maxLength: 22},
                  }}
                  value={enrollmentFields.allowance || ""}
                  name="allowance"
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  width: "50%",
                }}
              >
                <p className="input-label">Residence ID</p>
                <TextField
                  variant="outlined"
                  margin="none"
                  label=""
                  onChange={inputHandler}
                  value={enrollmentFields.resiID}
                  name="resiID"
                  sx={{ width: "190px" }}
                ></TextField>
              </Box>
            </Box>
          </Grid>
          {/* <p>Note : Fields marked as * are mandatory to be entered...!</p>  */}
          <p id="note">
            Note : Fields marked as * are mandatory to be entered...!
          </p>
          <Grid
            item
            xs={12}
            sx={{
              mt: "27px",
              mb: "27px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              sx={{ width: "260px", justifyContent: "space-between" }}
            >
              <ResetButton
                onClick={resetFields}
                variant="outlined"
                sx={{ width: "120px" }}
              >
                Reset
              </ResetButton>
            </Box>
            <Box>
              {action == "edit" ? (
                <BackButton
                  variant="outlined"
                  sx={{ minwidth: "140px" }}
                  onClick={() => {
                    // alert("your detials will not be saved. ");
                    navigate("/DirectDepositListing");
                  }}
                >
                  Back
                </BackButton>
              ) : (
                <>
                {location && location.state && location.state.routeName &&
                location.state.routeName != "" ?
                <BackButton
                  id="newbtn"
                  variant="outlined"
                  sx={{ minwidth: "140px", marginRight: "20px" }}
                  onClick={() => {
                    navigate("/directDepositListing");
                  }}
                >
                  Back
                </BackButton>
                :
                <BackButton
                  id="newbtn"
                  variant="outlined"
                  sx={{ minwidth: "140px", marginRight: "20px" }}
                  onClick={() => {
                    navigate("/home");
                  }}
                >
                  Back
                </BackButton>
              }
                </>
              )}

              <SubmitButton
                className="download-btn"
                id="newbtn"
                onClick={handleOpen}
                sx={{ minwidth: "140px !important", marginLeft: "20px" }}
                variant="contained"
              >
                Submit
              </SubmitButton>

              {open && (
                <EnrollmentModal
                  enrollmentFields={enrollmentFields}
                  open={open}
                  plzclose={handleClose}
                  requestsnackbardata={handlesnackbardata}
                  benefitTypeList={bt}
                  duplicateSsn={duplicateSsn}
                  duplicateMsg={duplicateMsg}
                  setSuccess={setSuccess}
                  setModalOpen={setModalOpen}
                />
              )}
            </Box>

            {/* <Fade
              in={snackbardata}
              timeout={{ appear: 100, enter: 1500, exit: 3000 }}
            >
              <Snackbar
                open={true}
                anchorOrigin={{ horizontal: "right", vertical: "top" }}
              >
                <Alert severity="success" sx={{ width: "100%" }}>
                  {enrollmentFields.firstName} ,Your Form has been submitted
                  successfully!Now, You will be redirected to
                  DirectDepositListingPage..!!
                </Alert>
              </Snackbar>
            </Fade> */}

          <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
          <>
            {success && (
              <Box sx={style}>
                <IconButton
                  sx={{ border: "2px solid green", boxShadow: "none" }}
                >
                  <Check sx={{ color: "green" }} />
                </IconButton>
                <p>
                  {action == "edit" ?
                  "Resident updated successfully!"
                  : "Resident enrolled successfully!"}
                </p>
                <Button
                  id="modal-close-btn"
                  variant="contained"
                  onClick={handleModalClose}
                >
                  Close
                </Button>
              </Box>
            )}
          </>
        </Modal>
          </Grid>
        </Grid>
      </Box>
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}

export default NewEnrollmentForm;